import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function ObjectionSection() {
  return <section className="bg-bark text-linen py-20 px-6 md:px-8" data-id="element-145">
      <div className="max-w-2xl mx-auto text-center" data-id="element-146">
        <AnimatedSection data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-serif text-linen mb-8" data-id="element-148">
            La objeción más común: <br data-id="element-149" />
            <span className="italic text-gold" data-id="element-150">“No tengo tiempo”</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-linen/90 leading-relaxed" data-id="element-151">
            <p data-id="element-152">Justamente.</p>
            <p data-id="element-153">Esto está diseñado para mujeres sin tiempo.</p>

            <p className="text-2xl font-serif" data-id="element-154">
              <span className="text-gold font-bold" data-id="element-155">7 minutos</span> no es
              “cuando tenga un rato”.
            </p>

            <p data-id="element-156">
              Es <span className="font-bold" data-id="element-157">antes de que el día te coma</span>{' '}
              o <span className="font-bold" data-id="element-158">antes de dormir</span>.
            </p>

            <p data-id="element-159">Y si un día es imposible:</p>
            <p data-id="element-160">hacés el guión de emergencia (3 min) y listo.</p>

            <div className="pt-6" data-id="element-161">
              <p className="text-3xl font-serif font-bold text-gold" data-id="element-162">
                No se rompe.
              </p>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}